import { useQuery } from 'react-query';
import { useMerchantId } from '../useMerchantId';
import { useAuthorizedClient } from '../../contexts/Auth';
import { Card } from './types';

function useCard() {
  const client = useAuthorizedClient();
  const merchantId = useMerchantId();

  return useQuery(
    ['card', { merchantId }],
    () =>
      client(`/v1/cards/?merchant_id=${merchantId}`, {}).then(
        (data: { card: Card }) => data?.card
      ),
    {
      useErrorBoundary: (error: any) => {
        return error?.status === 500;
      },
      retry: (_, error): any => {
        if (error?.status === 404 || error?.status === 403) {
          return false;
        } else {
          return true;
        }
      },
    }
  );
}

export { useCard };
